module.exports = __webpack_public_path__ + "img/project7_2.png.3c38bded.webp";